import { Component, OnDestroy, OnInit, QueryList, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import _ from 'lodash';
import { Subject, takeUntil } from 'rxjs';
import { Client } from 'src/app/model/client';
import { CalibrationParticlePattern, ParticleCalibration } from 'src/app/model/particleCalibration';
import { User } from 'src/app/model/user';
import { SpinnerService } from 'src/app/services/spinner.service';
import { UserService } from 'src/app/services/user.service';
import { Constants } from 'src/app/utils/constants';
import { DateTime } from 'luxon';
import { ClientService } from 'src/app/services/client.service';
import { TranslateService } from '@ngx-translate/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { ParticleCalibrationService } from 'src/app/services/particleCalibration.service';
import { DateUtils } from 'src/app/utils/dateUtils';
import { InternalEquipment } from 'src/app/model/internalEquipment';
import { ManageGroupsService } from 'src/app/services/manageGroups.service';
import { GroupUtils } from 'src/app/utils/groupUtils';
import { Group } from 'src/app/model/group';
import { InternalEquipmentService } from 'src/app/services/internalEquipment.service';
import { ConfirmationDialogComponent } from '../../shared/confirmation-dialog/confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ParticleTest, ParticleTestResult, ParticleTestType } from 'src/app/model/particleTest';
import { SnackBarService } from 'src/app/services/snackBar.service';
import { CalibrationStatus } from 'src/app/model/calibration';
import { ParticlesEditPatternsDialogComponent } from './particles-edit-patterns-dialog/particles-edit-patterns-dialog.component';

import { EquipmentAutocompleteFilter } from 'src/app/model/autocompleteFilter';
import { MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { ParticlesEditAuditComponent } from './particles-edit-audit.component';
import { ParticlesPatternDataSource } from 'src/app/model/particlesPatternDataSource';
import { CalibrationPatternService } from 'src/app/services/calibrationParticlesPattern.service';
import { MatOptionSelectionChange } from '@angular/material/core';
import { CalibrationPlaceService } from 'src/app/services/calibrationPlace.service';
import { GenericClassTranslate } from 'src/app/model/genericClass';
import { EquipmentReceptionStatusService } from 'src/app/services/equipmentReceptionStatus.service';
import { Procedure } from 'src/app/model/procedure';
import { ProcedureService } from 'src/app/services/procedure.service';
import { ParticlesEditDialogTestEditComponent } from './particles-edit-dialog-test-edit/particles-edit-dialog-test-edit.component';
import { CountingEfficiencyService } from 'src/app/services/countigEfficiency.service';
import { CountingEfficiency } from 'src/app/model/countingEfficiency';
import { ParticleTestEnum, ParticleTestTypeEnum } from 'src/app/utils/particleTestUtils';
import { StringUtils } from '../../../utils/stringUtils';
import { ArrayUtils } from '../../../utils/arrayUtils';
import { ActionConfirmPasswordComponent } from '../../shared/action-confirm-password/action-confirm-password.component';
import { ParticlesEditAutomaticSignReportComponent } from './particles-edit-automatic-sign-report/particles-edit-automatic-sign-report.component';
import { ParticlesEditManualSignReportComponent } from './particles-edit-manual-sign-report/particles-edit-manual-sign-report.component';
import { RoleEnum } from '../../../model/roleUser';
import { GenericClass } from '../../../model/genericClass';
import { CalibrationStatusService } from '../../../services/calibrationStatus.service';
import { ReasonDialogComponent } from '../../shared/reason-dialog/reason-dialog.component';
import { CalibrationBalanceStatus } from '../../../model/calibrationBalance';
import { CalibrationParticlesUtils } from '../../../utils/calibrationParticlesUtils';
import saveAs from 'file-saver';
import { InternalEquipmentTypeEnum } from '../../../model/internalEquipment';
import { CalibrationResponsibleEnum } from '../../../model/particleCalibration';
import { ParticlesEditCreateEquipmentComponent } from './particles-edit-create-equipment/particles-edit-create-equipment.component';
import { EquipmentPerformances } from '../../../utils/equipmentUtils';
import { AppTypeEnum } from '../../../model/appType';
@Component({
  selector: 'app-particles-edit',
  templateUrl: './particles-edit.component.html',
  styleUrls: ['./particles-edit.component.scss'],
  standalone: false
})
export class ParticlesEditComponent implements OnInit, OnDestroy {

  @ViewChild(ParticlesEditAuditComponent) audit: ParticlesEditAuditComponent;

  calibration: ParticleCalibration;
  clientAddress: string;
  clientName: string;
  clients: Client[];
  clientsFiltered: Client[];
  places: GenericClassTranslate[];
  receptionStatus: GenericClassTranslate[];
  procedures: Procedure[];
  currentUser: User;
  equipment: InternalEquipment;
  idClientSelected: number;
  maxDateCalibration = new Date();
  testTypes: ParticleTestType[];
  testTypesAf: ParticleTestType[];
  testTypesAl: ParticleTestType[];
  tests: ParticleTest[];
  testsAf: ParticleTest[] = [];
  testsAl: ParticleTest[] = [];
  selectedTestsAf: ParticleTestType[] = [];
  selectedTestsAl: ParticleTestType[] = [];
  testsSelected: ParticleTest[];
  statuses: GenericClass[];
  patternCols = ['name', 'maker', 'model', 'serialNum', 'equipment', 'expirationDate', 'edit', 'delete'];
  dataSource: ParticlesPatternDataSource;

  private readonly destroy$ = new Subject<void>();

  public equipmentAutoComplete: InternalEquipment[];

  constructor(
    public dialog: MatDialog,
    private readonly clientService: ClientService,
    private readonly manageGroupsService: ManageGroupsService,
    private readonly particleService: ParticleCalibrationService,
    private readonly particlePatternService: CalibrationPatternService,
    private readonly internalEquipmentService: InternalEquipmentService,
    private readonly calibrationPlaceService: CalibrationPlaceService,
    private readonly equipmentReceptionService: EquipmentReceptionStatusService,
    private readonly countingEfficiencyService: CountingEfficiencyService,
    private readonly procedureService: ProcedureService,
    private readonly calibrationStatusService: CalibrationStatusService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    public snackBarService: SnackBarService,
    private readonly spinnerService: SpinnerService,
    private readonly translate: TranslateService,
    private readonly userService: UserService
  ) {
    this.spinnerService.show();
    this.currentUser = this.userService.currentProfile;
    this.dataSource = new ParticlesPatternDataSource(this.particlePatternService);
    this.equipment = new InternalEquipment();
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
      const id = params[Constants.FIELD_ID] as number;
      const idEquipment = params[Constants.FIELD_ID_EQUIPMENT] as number;
      this.particleService.findAllTestType().pipe(takeUntil(this.destroy$)).subscribe((result: ParticleTestType[]) => {
        this.testTypes = result;
        this.testTypesAf = this.testTypes.filter(type => type.type == ParticleTestTypeEnum.AS_FOUND);
        this.testTypesAl = this.testTypes.filter(type => type.type == ParticleTestTypeEnum.AS_LEFT);
      });
      if (id == null || isNaN(+id)) {
        this.cancel();
      }

      this.calibration = new ParticleCalibration();

      if (+id === 0) {
        this.calibration.calibrationDate = DateTime.now().toJSDate();
        this.clientService.findAll().pipe(takeUntil(this.destroy$)).subscribe((clients: Client[]) => {
          this.clients = clients;
          this.clientsFiltered = this.clients;
        });

        if (idEquipment != null) {
          this.spinnerService.show();
          this.internalEquipmentService.findOne(idEquipment).pipe(takeUntil(this.destroy$)).subscribe((eq: InternalEquipment) => {
             this.onEquipmentChange(eq);
             this.idClientSelected = eq.internal ? -1 : eq.idClient;
             if (eq.calibrationFrequency && eq.calibrationFrequency?.match('^[0-9]+$')) {
               this.calibration.expirationDate = _.cloneDeep(this.calibration.calibrationDate);
               this.calibration.expirationDate.setMonth(this.calibration.expirationDate.getMonth() + Number(eq.calibrationFrequency));
             } else {
               if (!this.calibration.expirationDate) {
                 this.calibration.expirationDate = _.cloneDeep(this.calibration.calibrationDate);
                 this.calibration.expirationDate.setFullYear(this.calibration.expirationDate.getFullYear() + 1);
               }
             }
             this.spinnerService.hide();
           }, () => this.spinnerService.hide());
        } else {
          this.spinnerService.hide();
        }
      } else {
        this.particleService.findOne(id).pipe(takeUntil(this.destroy$)).subscribe((result: any) => {
          if (result != null) {
            this.calibration = result;
            this.dataSource.loadPatterns(this.calibration.id);
            this.calibration.calibrationDate = DateUtils.anyToDate(this.calibration.calibrationDate);
            this.calibration.expirationDate = DateUtils.anyToDate(this.calibration.expirationDate);
            this.testsAf = this.calibration.tests.filter(test => test.type === 1);
            this.testsAl = this.calibration.tests.filter(test => test.type === 2);

            this.selectedTestsAf = this.testTypesAf.filter(type =>
              this.testsAf.some(t => t.idTestType === type.id)
            );
            this.selectedTestsAl = this.testTypesAl.filter(type =>
              this.testsAl.some(t => t.idTestType === type.id)
            );

            this.internalEquipmentService.findOne(this.calibration.idEquipment).pipe(takeUntil(this.destroy$))
              .subscribe((item: InternalEquipment) => {
                this.equipment = item;
                this.calculateClientData();
              }, () => this.spinnerService.hide());
          } else {
            this.calibration = null;
          }
        }, () => {
          this.cancel();
        });
      }

    });
  }
  compareById = (a: any, b: any): boolean => a?.id === b?.id;

  ngOnInit(): void {
    this.statuses = [];
    this.places = [];
    this.receptionStatus = [];
    this.procedures = [];
    this.calibrationPlaceService.findAll().pipe(takeUntil(this.destroy$)).subscribe((data: GenericClassTranslate[]) => this.places = data);
    this.equipmentReceptionService.findAll().pipe(takeUntil(this.destroy$)).subscribe((data: GenericClassTranslate[]) => this.receptionStatus = data);
    this.procedureService.getProceduresByIdApplication(AppTypeEnum.CALIBRATES).pipe(takeUntil(this.destroy$)).subscribe((data: Procedure[]) => this.procedures = data);
    this.calibrationStatusService.findAll().pipe(takeUntil(this.destroy$)).subscribe((data: GenericClass[]) => this.statuses = data);
  }

  ngOnDestroy(): void {

  }

  cancel(): void {
    void this.router.navigateByUrl('particles/calibrations');
  }

  showRevertSign(): boolean {
    const resultRol = this.currentUser?.profiles?.find(e => e.idRole === RoleEnum.MANAGER || e.idRole === RoleEnum.ADMIN);
    return this.calibration.id != null && this.calibration.idStatus === CalibrationStatus.FIRMADO
      && (resultRol != null && resultRol !== undefined);
  }

  showBack(): boolean {
    return this.calibration.id != null && this.calibration.idStatus === CalibrationStatus.PENDIENTE_FIRMA;
  }


  saveCalibration() {
    if (this.idClientSelected != null) {
      this.calibration.idClient = this.idClientSelected;
    }

     const dialogRef = this.dialog.open(ActionConfirmPasswordComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {}
    });

      dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((token: string) => {

        if (token != null) {
          this.spinnerService.show();

          this.prepareToSave();
          
          this.particleService.save(this.calibration, "").pipe(takeUntil(this.destroy$))
            .subscribe((res: ParticleCalibration) => {
              var isNew = this.calibration.id != null;
              this.calibration = res;

              if (isNew) {
                this.snackBarService.sendSuccess(this.translate.instant('calibrateEquipmentEdit.form.create.ok') as string);
              } else {
                this.snackBarService.sendSuccess(this.translate.instant('calibrateEquipmentEdit.form.update.ok') as string);
              }
              this.spinnerService.hide();
              this.reloadPage(this.calibration.id);

            }
            , error => {
              this.spinnerService.hide();
              this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.form.update.error') as string);

            });
          }
      });
  }

  showAdvance(): boolean {
    return this.calibration.id != null && this.calibration.idStatus === CalibrationStatus.EN_EJECUCION;
  }

  calculateAdvance() {
    this.spinnerService.show();

    const errors = this.checkCalibration(false, true);

    if (errors.length !== 0) {
      this.spinnerService.hide();
      this.snackBarService.sendError(errors.join('\n'));

      return;
    }

    const dialogRef = this.dialog.open(ActionConfirmPasswordComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {}
    });

    this.spinnerService.hide();

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((token: string) => {
      if (token) {
        this.spinnerService.show();

        this.particleService.save(this.calibration, token).pipe(takeUntil(this.destroy$)).subscribe(() => {
          this.particleService.advance(this.calibration, token).pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.spinnerService.hide();
            this.reloadPage(this.calibration.id);
          });
        });
      }
    }, error => {
      if (error != null && error.error != null && typeof error.error === 'string') {
        this.snackBarService.sendError(error.error as string);
      } else {
        this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.form.status.advance.error.generic') as string);
      }
    });
  }

  manualSign(): void {
    const errors = this.checkCalibration(false, true);

    if (errors.length !== 0) {
      this.snackBarService.sendError(errors.join('\n'));

      return;
    }

    this.prepareToSave();

    const dialogRef = this.dialog.open(ParticlesEditManualSignReportComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {
        calibration: this.calibration,
        reason: this.calibration.reason
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(res => {

      if (res != null) {
        this.findClient();
      }
      this.spinnerService.hide();
    });
  }

  automaticSign() {
    const errors = this.checkCalibration(false, true);

    if (errors.length !== 0) {
      this.snackBarService.sendError(errors.join('\n'));

      return;
    }

    this.prepareToSave();

    const dialogRef = this.dialog.open(ParticlesEditAutomaticSignReportComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {
        calibration: this.calibration,
        equipment: this.equipment
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(res => {

      if (res != null) {

        this.findClient();

      }
      this.spinnerService.hide();
    });
  }

  userCanModify(): boolean {
    const profile = this.userService.currentProfile;

    if (profile == null || this.calibration.idStatus === CalibrationStatus.NO_VALIDO) {
      return false;
    }

    return true;
  }

  showInvalidate(): boolean {
    return this.calibration.id != null && this.calibration.idStatus !== CalibrationStatus.NO_VALIDO;
  }

  showAutomaticSign(): boolean {
    const current = this.currentUser;

    return this.showSign() && current.automaticSign;
  }

  showManualSign(): boolean {
    const current = this.currentUser;

    return this.showSign() && current.manualSign;
  }
  isEditable(): boolean {
    return this.calibration.idStatus === CalibrationStatus.FIRMADO || this.calibration.idStatus === CalibrationStatus.NO_VALIDO;
  }

  downloadPdf() {
    const errors = this.checkCalibration(false, false);

    if (errors.length !== 0) {
        this.snackBarService.sendError(errors.join('\n'));

        return;
      }

      if (this.calibration.idStatus === CalibrationBalanceStatus.FIRMADO) {
        this.spinnerService.show();
    
        this.particleService.downloadPdfCalibrationVersion(this.calibration).pipe(takeUntil(this.destroy$)).subscribe((res: File) => {
          this.downloadFile(this.calibration, res);
        }, () => {
          this.snackBarService.sendError(
            this.translate.instant('calibrateEquipmentEdit.dialog.generateReport.form.error.notFound') as string);
          this.spinnerService.hide();
        });
      } else {
        this.spinnerService.show();
        
        this.particleService.downloadPdf(this.calibration.id).subscribe(
          (data: Blob) => {
            const file = new Blob([data], { type: 'application/pdf' });
            const fileURL = URL.createObjectURL(file);

            const a = document.createElement('a');
            a.href = fileURL;
            a.download = `${this.calibration.certificateNum}.pdf`;
            document.body.appendChild(a);
            a.click();
            a.remove();

            URL.revokeObjectURL(fileURL);
            this.spinnerService.hide();
          },
          (error) => {
            this.spinnerService.hide();
          }
        );
        
      }
  }

  saveDate(field: string, event: any): void {
    let value: Date | string = event.value;

    if (value != null) {

      if (value instanceof Date) {
        value = DateTime.fromFormat(value, 'dd/MM/yyyy').toFormat('dd/MM/yyyy');
      }

      const date = DateTime.fromFormat(value + ' 12:00:00 + 0:00', 'dd/MM/yyyy HH:mm:ss ZZZ').toJSDate();

      while (date.getFullYear() < 1970) {
        date.setFullYear(date.getFullYear() + 100);
      }

      this.calibration[field] = date;

      if (field === 'calibrationDate') {
        //      if (this.equipment.calibrationFrequency && this.equipment.calibrationFrequency?.match('^[0-9]+$')) {
        //      this.calibration.expirationDate = _.cloneDeep(this.calibration.calibrationDate);
        //    this.calibration.expirationDate.setMonth(this.calibration.expirationDate.getMonth() + Number(this.equipment.calibrationFrequency));
        //  } else {
        this.calibration.expirationDate = _.cloneDeep(this.calibration.calibrationDate);
        this.calibration.expirationDate.setFullYear(this.calibration.expirationDate.getFullYear() + 1);
        // }
      }

    } else {
      this.calibration[field] = null;
    }

  }


  onTabChange(event: MatTabChangeEvent): void {
    if (event.index === 1) {
      this.audit.getAudit();
    }
  }
  onClientChange(event: MatAutocompleteSelectedEvent | number): void {
    let idClient;
    if (event instanceof MatAutocompleteSelectedEvent) {
      idClient = (event.option.value as number);
    } else {
      idClient = event;
    }
    this.calibration.idClient = idClient;
  }

  openDialogEditTest(index: number, testType: number) {
    let testToEdit: ParticleTest;

    if (testType === ParticleTestTypeEnum.AS_FOUND) {
      testToEdit = this.testsAf[index];
    } else {
      testToEdit = this.testsAl[index];
    }

    const name = this.getTestName(testToEdit.idTestType);
    const dialogRef = this.dialog.open(ParticlesEditDialogTestEditComponent, {
      minWidth: '80%',
      maxHeight: '95vh',
      data: {
        calibration: this.calibration,
        test: _.cloneDeep(testToEdit),
        name: name,
        testTypes: this.testTypes
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: ParticleTest) => {
      if (result) {
        if (testType === ParticleTestTypeEnum.AS_FOUND) {
          this.testsAf[index] = result;
        } else {
          this.testsAl[index] = result;
        }
        const indexResult = this.calibration.tests.findIndex(ct => ct.idTestType === result.idTestType);
        this.calibration.tests[indexResult] = result;

        if (result != null && result.type == ParticleTestTypeEnum.AS_FOUND) {
          const allPassed = result.results?.every(r => r.pass === true);
          if (!allPassed) {
            return;
          }

          const isDuplicate = this.testsAl.some(
            t => t.translation === result.translation.replace('_af', '_al')
          );


          if (isDuplicate) {
            return;
          }
          const newTest = { ...result };
          newTest.type = ParticleTestTypeEnum.AS_LEFT;
          newTest.translation = result.translation.replace('_af', '_al');
          const testType = this.testTypesAl.find(tt => tt.translation === newTest.translation);
          newTest.idTestType = testType.id;

          this.testsAl.push(newTest);
          this.calibration.tests.push(newTest);

          if (testType && !this.selectedTestsAl.some(sel => sel.id === testType.id)) {
            this.selectedTestsAl = [...this.selectedTestsAl, testType];
          }
        }
      }
    });
  }

  deleteTest(index: number) {
    const message = this.translate.instant('protocolEdit.dialog.room.form.confirmDelete') as string;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(response => {
      if (response === true) {
        if (index > -1) {
          this.calibration.tests.splice(index, 1);
        }
      }
    });
  }

  getTestName(id: number): string {
    return this.translate.instant("particleTestType." + this.testTypes.find(tt => tt.id === id).translation);
  }

  reloadPage(idCalibration: number): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    let url: string;
    url = `particles/calibration?id=${idCalibration}`

    void this.router.navigateByUrl(url);
  }

  newPatternRow(): void {

    const dialogRef = this.dialog.open(ParticlesEditPatternsDialogComponent, {
      minWidth: '50%',
      maxHeight: '95vh',
      data: {
        pattern: new CalibrationParticlePattern(),
        idsRemove: this.calibration.patterns?.map(p => p.idEquipment)
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: CalibrationParticlePattern) => {
      if (result != null) {
        this.calibration.patterns.push(result);
        this.dataSource.addPattern(result);
      }
    });
  }

  editPatternRow(index: number): void {
    const pattern = this.calibration.patterns[index];

    const dialogRef = this.dialog.open(ParticlesEditPatternsDialogComponent, {
      minWidth: '50%',
      maxHeight: '95vh',
      data: {
        pattern: pattern,
        idsRemove: this.calibration.patterns?.map(p => p.idEquipment)
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: InternalEquipment) => {
      if (result != null) {
        pattern.equipment = result;
        pattern.idEquipment = result.id;

        this.dataSource?.updatePattern?.(pattern);
      }
    });
  }
  deletePatternRow(index: number) {
    event.stopPropagation();

    const message = this.translate.instant('protocolEdit.dialog.room.form.confirmDelete') as string;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, { data: { message } });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(response => {
      if (response === true) {
        if (index > -1) {
          this.calibration.patterns.splice(index, 1);
          this.dataSource.deletePattern(index);
        }
      }
    });
  }

  invalidate(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: this.translate.instant('calibrateEquipmentEdit.form.invalidate.confirm') as string
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
      if (result === true) {
        this.requestReason((reason) => {

          const dialogPass = this.dialog.open(ActionConfirmPasswordComponent, {
            minWidth: '20%',
            maxHeight: '95vh',
            data: {}
          });

          dialogPass.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((token: string) => {
            if (token != null) {
              this.spinnerService.show();

              this.particleService.invalidate(this.calibration.id, token, reason).pipe(takeUntil(this.destroy$)).subscribe(() => {
                this.reloadPage(this.calibration.id);
              });
              this.spinnerService.hide();
            }
          }, error => {
            if (error != null && error.error != null && typeof error.error === 'string') {
              this.snackBarService.sendError(error.error as string);
            } else {
              this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.form.status.back.error.generic') as string);
            }
          });
        });
      }
    });
  }

  private onEquipmentChange(equipmentSelected: InternalEquipment) {

    this.equipment = equipmentSelected;
    this.calibration.idEquipment = equipmentSelected.id;
    if (this.equipment?.calibrationFrequency && this.equipment?.calibrationFrequency?.match('^[0-9]+$')) {
      this.calibration.expirationDate = _.cloneDeep(this.calibration.calibrationDate);
      this.calibration.expirationDate.setMonth(this.calibration.expirationDate.getMonth() + Number(this.equipment.calibrationFrequency));
    } else {
      this.calibration.expirationDate = _.cloneDeep(this.calibration.calibrationDate);
      this.calibration.expirationDate.setFullYear(this.calibration.expirationDate.getFullYear() + 1);
    }
    this.calculateClientData();
  }

  private calculateClientData() {
    if (this.equipment.client != null) {
      this.clientName = this.equipment.client.name;
      this.clientAddress = this.equipment.client.addressLine1 + '\n' + this.equipment.client.addressLine2;

      this.spinnerService.hide();
    } else {
      this.manageGroupsService.findCurrent().pipe(takeUntil(this.destroy$)).subscribe((g: Group) => {
        g = GroupUtils.objectToGroup(g);
        this.clientName = g.name;
        this.clientAddress = g.getFullAddress();

        this.spinnerService.hide();
      }, () => this.spinnerService.hide());
    }
  }

  lookupEquipment($event): void {
    let results = this.equipmentAutoComplete;

    const filter = new EquipmentAutocompleteFilter();

    filter.query = $event.target.value as string;
    filter.pageIndex = 0;
    filter.pageSize = 10;
    filter.sortBy = 'name';
    filter.sortDirection = 'asc';
    filter.forParticles = true;

    if (this.idClientSelected != null) {
      if (typeof this.idClientSelected === 'string') {
        if (this.idClientSelected !== '-1') {
          filter.idClient = Number(this.idClientSelected);
        } else {
          filter.internalEquipment = true;
        }
      } else {
        if (this.idClientSelected !== -1) {
          filter.idClient = this.idClientSelected;
        } else {
          filter.internalEquipment = true;
        }
      }
    }

    this.internalEquipmentService.findAutocomplete(filter).pipe(takeUntil(this.destroy$)).subscribe(item => {
      results = item.content;
      this.equipmentAutoComplete = results;
    }, () => {
      results = [];
      this.equipmentAutoComplete = results;
    });
  }

  onSensorChange($event: any, trigger: MatAutocompleteTrigger): void {
    const equipmentSelected = $event.option.value as InternalEquipment;

    this.onEquipmentChange(equipmentSelected);

    event.stopPropagation();
    trigger.closePanel();
  }

  onChangeAsFoundCheck(event: MatOptionSelectionChange): void {
    if (!event.isUserInput) {
      return;
    }

    const testType = event.source.value as ParticleTestType;
    this.calibration.tests ??= [];

    if (event.source.selected) {
      const test = new ParticleTest();
      test.idTestType = testType.id;
      test.translation = testType.translation;
      test.type = ParticleTestTypeEnum.AS_FOUND;
      test.results = [];

      if (test.idTestType == ParticleTestEnum.COUNTING_EFFICIENCY_AF) {
        this.countingEfficiencyService.findAll().pipe(takeUntil(this.destroy$)).subscribe((configurations: CountingEfficiency[]) => {
          configurations.forEach(count => {
            const result = new ParticleTestResult();
            result.limit = count.lowerLimit + "-" + count.upperLimit;
            result.efficiencyTest = count.efficiency;
            test.results.push(result);
          });
          this.testsAf.push(test);
          this.calibration.tests.push(test);
        })

      } else if (test.idTestType == ParticleTestEnum.SLAMPING_TIME_AF) {
        const result = new ParticleTestResult();
        result.limit = "60 ± 1%";
        test.results.push(result);
        this.testsAf.push(test);
        this.calibration.tests.push(test);
      }
      else if (test.idTestType == ParticleTestEnum.FALSE_COUNT_AF) {
        const result = new ParticleTestResult();
        result.limit = "<= 1cnt / 5 min";
        test.results.push(result);
        this.testsAf.push(test);
        this.calibration.tests.push(test);
      } else {
        let result = new ParticleTestResult();

        if (testType.id == ParticleTestEnum.PEAK_NOISE_AF) {
          const sizeSettingTest = this.testsAf.find(item => item.idTestType === 2);
          result.limit = ">" + this.testTypes.find(item => item.id === testType.id).limite.toString();
          if (sizeSettingTest) {
            if (sizeSettingTest?.results?.length) {
              let minMedian = sizeSettingTest.results[0].median;
              sizeSettingTest.results.forEach(item => {
                const median = item.median;

                if (median < minMedian) {
                  minMedian = median;
                }
              });

              result.signal = minMedian;
            }
          }
          test.results.push(result);

          this.testsAf.push(test);
          this.calibration.tests.push(test);
        } else {
          const result = new ParticleTestResult();
          result.limit = "<" + this.testTypes.find(item => item.id === testType.id).limite.toString() + "%";
          test.results.push(result);
          this.testsAf.push(test);
          this.calibration.tests.push(test);
        }

      }

    } else {
      this.testsAf = this.testsAf.filter(item => item.idTestType !== testType.id);
      this.calibration.tests = this.calibration.tests.filter(item => !(item.idTestType === testType.id && item.type === ParticleTestTypeEnum.AS_FOUND));
    }
  }
  onChangeAsLeftCheck(event: MatOptionSelectionChange): void {
    if (!event.isUserInput) {
      return;
    }

    const testType = event.source.value as ParticleTestType;

    this.calibration.tests ??= [];
    if (event.source.selected) {
      const test = new ParticleTest();
      test.idTestType = testType.id;
      test.translation = testType.translation;
      test.type = ParticleTestTypeEnum.AS_LEFT;
      test.results = [];

      if (test.idTestType == ParticleTestEnum.COUNTING_EFFICIENCY_AL) {
        this.countingEfficiencyService.findAll().pipe(takeUntil(this.destroy$)).subscribe((configurations: CountingEfficiency[]) => {
          configurations.forEach(count => {
            const result = new ParticleTestResult();
            result.limit = count.lowerLimit + "-" + count.upperLimit;
            result.efficiencyTest = count.efficiency;
            test.results.push(result);
          });
          this.testsAl.push(test);
          this.calibration.tests.push(test);
        })

      } else if (test.idTestType == ParticleTestEnum.SLAMPING_TIME_AL) {
        const result = new ParticleTestResult();
        result.limit = "60 ± 1%";
        test.results.push(result);
        this.testsAl.push(test);
        this.calibration.tests.push(test);
      }
      else if (test.idTestType == ParticleTestEnum.FALSE_COUNT_AL) {
        const result = new ParticleTestResult();
        result.limit = "<= 1cnt / 5 min";
        test.results.push(result);
        this.testsAl.push(test);
        this.calibration.tests.push(test);
      }
      else {
        let result = new ParticleTestResult();

        if (testType.id == ParticleTestEnum.PEAK_NOISE_AL) {
          const sizeSettingTest = this.testsAl.find(item => item.idTestType === 9);
          result.limit = ">" + this.testTypes.find(item => item.id === testType.id).limite.toString();
          if (sizeSettingTest) {
            if (sizeSettingTest?.results?.length) {
              let minMedian = sizeSettingTest.results[0].median;
              sizeSettingTest.results.forEach(item => {
                const median = item.median;

                if (median < minMedian) {
                  minMedian = median;
                }
              });

              result.signal = minMedian;
            }
          }
          test.results.push(result);

          this.testsAl.push(test);
          this.calibration.tests.push(test);
        } else {
          const result = new ParticleTestResult();
          result.limit = "<" + this.testTypes.find(item => item.id === testType.id).limite.toString() + "%";
          test.results.push(result);
          this.testsAl.push(test);
          this.calibration.tests.push(test);
        }

      }

    } else {
      this.testsAl = this.testsAl.filter(item => item.idTestType !== testType.id);
      this.calibration.tests = this.calibration.tests.filter(item => !(item.idTestType === testType.id && item.type === ParticleTestTypeEnum.AS_LEFT));
    }
  }

  showDownloadButton(): boolean {
    return this.calibration.id != null && this.calibration.hasOwnProperty('id')
      && this.calibration.idStatus !== CalibrationStatus.EN_EJECUCION && this.calibration.idStatus !== CalibrationStatus.NO_VALIDO;
  }

  calculateBack(): void {
    const errors = this.checkCalibration(false, false);

    if (errors.length !== 0) {
      this.snackBarService.sendError(errors.join('\n'));

      return;
    }

    const dialogRef = this.dialog.open(ActionConfirmPasswordComponent, {
      minWidth: '20%',
      maxHeight: '95vh',
      data: {}
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((token: string) => {
      if (token) {
        this.particleService.back(this.calibration, token).pipe(takeUntil(this.destroy$)).subscribe(() => {
          this.spinnerService.hide();
          this.reloadPage(this.calibration.id);
        });
      }
    }, error => {
      if (error != null && error.error != null && typeof error.error === 'string') {
        this.snackBarService.sendError(error.error as string);
      } else {
        this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.form.status.back.error.generic') as string);
      }
    });
  }

  createEquipment(): void {
    this.dialog.open(ParticlesEditCreateEquipmentComponent, {
      minWidth: '50%',
      maxHeight: '95vh',
      data: {
        idType: this.idClientSelected === -1 ? CalibrationResponsibleEnum.INTERNAL : CalibrationResponsibleEnum.EXTERNAL,
        idClient: this.idClientSelected === -1 ? null : this.idClientSelected,
        idEquipmentType: InternalEquipmentTypeEnum.PARTICLES.id
      }
    });
  }

  getDateExpiration(pattern: CalibrationParticlePattern): Date {
    return pattern?.equipment?.performances.find(f => f.idActionType === EquipmentPerformances.CALIBRATION)?.expirationDate;
  }

  showNominal(test: ParticleTest): boolean {
    const visibleIds = [ParticleTestEnum.FLOW_RATE_AF, ParticleTestEnum.FLOW_RATE_AL];
    return visibleIds.includes(test.idTestType);
  }

  showChannel(test: ParticleTest): boolean {
    const visibleIds = [ParticleTestEnum.SIZE_SETTING_AF, ParticleTestEnum.SIZE_SETTING_AL];
    return visibleIds.includes(test.idTestType);
  }

  showLimit(test: ParticleTest): boolean {
    const visibleIds = [
      ParticleTestEnum.FLOW_RATE_AF,
      ParticleTestEnum.SIZE_SETTING_AF,
      ParticleTestEnum.COUNTING_EFFICIENCY_AF,
      ParticleTestEnum.PEAK_NOISE_AF,
      ParticleTestEnum.SLAMPING_TIME_AF,
      ParticleTestEnum.FALSE_COUNT_AF,
      ParticleTestEnum.SIZE_RESOLUTION_AF,
      ParticleTestEnum.FLOW_RATE_AL,
      ParticleTestEnum.SIZE_SETTING_AL,
      ParticleTestEnum.COUNTING_EFFICIENCY_AL,
      ParticleTestEnum.PEAK_NOISE_AL,
      ParticleTestEnum.SLAMPING_TIME_AL,
      ParticleTestEnum.FALSE_COUNT_AL,
      ParticleTestEnum.SIZE_RESOLUTION_AL,
    ];

    return visibleIds.includes(test.idTestType);
  }

  showMessuared(test: ParticleTest): boolean {
    const visibleIds = [ParticleTestEnum.FLOW_RATE_AF, ParticleTestEnum.FLOW_RATE_AL];
    return visibleIds.includes(test.idTestType);
  }

  showResult(test: ParticleTest): boolean {
    const visibleIds = [
      ParticleTestEnum.FLOW_RATE_AF,
      ParticleTestEnum.SIZE_SETTING_AF,
      ParticleTestEnum.PEAK_NOISE_AF,
      ParticleTestEnum.SLAMPING_TIME_AF,
      ParticleTestEnum.FLOW_RATE_AL,
      ParticleTestEnum.SIZE_SETTING_AL,
      ParticleTestEnum.PEAK_NOISE_AL,
      ParticleTestEnum.SLAMPING_TIME_AL,
    ];
    return visibleIds.includes(test.idTestType);
  }

  showMedian(test: ParticleTest): boolean {
    const visibleIds = [ParticleTestEnum.SIZE_SETTING_AF, ParticleTestEnum.SIZE_SETTING_AL];
    return visibleIds.includes(test.idTestType);
  }

  showPreviousValue(test: ParticleTest): boolean {
    const visibleIds = [ParticleTestEnum.SIZE_SETTING_AF, ParticleTestEnum.SIZE_SETTING_AL];
    return visibleIds.includes(test.idTestType);
  }

  showAjustedValue(test: ParticleTest): boolean {
    const visibleIds = [ParticleTestEnum.SIZE_SETTING_AF, ParticleTestEnum.SIZE_SETTING_AL];
    return visibleIds.includes(test.idTestType);
  }

  showSize(test: ParticleTest): boolean {
    const visibleIds = [ParticleTestEnum.COUNTING_EFFICIENCY_AF, ParticleTestEnum.COUNTING_EFFICIENCY_AL];
    return visibleIds.includes(test.idTestType);
  }

  showObtainedEfficiency(test: ParticleTest): boolean {
    const visibleIds = [ParticleTestEnum.COUNTING_EFFICIENCY_AF, ParticleTestEnum.COUNTING_EFFICIENCY_AL];
    return visibleIds.includes(test.idTestType);
  }

  showMeasuredNoise(test: ParticleTest): boolean {
    const visibleIds = [ParticleTestEnum.PEAK_NOISE_AF, ParticleTestEnum.PEAK_NOISE_AL];
    return visibleIds.includes(test.idTestType);
  }

  showMeasuredSignal(test: ParticleTest): boolean {
    const visibleIds = [ParticleTestEnum.PEAK_NOISE_AF, ParticleTestEnum.PEAK_NOISE_AL];
    return visibleIds.includes(test.idTestType);
  }

  showEfficiencyTest(test: ParticleTest): boolean {
    const visibleIds = [ParticleTestEnum.COUNTING_EFFICIENCY_AF, ParticleTestEnum.COUNTING_EFFICIENCY_AL];
    return visibleIds.includes(test.idTestType);
  }

  showObsAccounts(test: ParticleTest): boolean {
    const visibleIds = [ParticleTestEnum.FALSE_COUNT_AF, ParticleTestEnum.FALSE_COUNT_AL];
    return visibleIds.includes(test.idTestType);
  }

  showObtResolucion(test: ParticleTest): boolean {
    const visibleIds = [ParticleTestEnum.SIZE_RESOLUTION_AF, ParticleTestEnum.SIZE_RESOLUTION_AL];
    return visibleIds.includes(test.idTestType);
  }

  showSizeCertificate(test: ParticleTest): boolean {
    const visibleIds = [ParticleTestEnum.SIZE_RESOLUTION_AF, ParticleTestEnum.SIZE_RESOLUTION_AL];
    return visibleIds.includes(test.idTestType);
  }

  showCountTime(test: ParticleTest): boolean {
    const visibleIds = [ParticleTestEnum.SLAMPING_TIME_AF, ParticleTestEnum.SLAMPING_TIME_AL];
    return visibleIds.includes(test.idTestType);
  }

  showStandarTime(test: ParticleTest): boolean {
    const visibleIds = [ParticleTestEnum.SLAMPING_TIME_AF, ParticleTestEnum.SLAMPING_TIME_AL];
    return visibleIds.includes(test.idTestType);
  }

  private checkCalibration(isForSave: boolean, isForAdvance: boolean): string[] {
    const errors: string[] = [];

    if (this.calibration.idEquipment == null) {
      errors.push(this.translate.instant('calibrateEquipmentEdit.general.name.error') as string);
    }

    if (StringUtils.isEmpty(this.calibration.certificateNum)) {
      errors.push(this.translate.instant('calibrateEquipmentEdit.general.certificateNum.error') as string);
    }

    if (this.calibration.calibrationDate == null) {
      errors.push(this.translate.instant('calibrateEquipmentEdit.general.calibrateDate.error') as string);
    }

    if (isForAdvance) {
      if (!isForSave && this.calibration.id != null && this.calibration.idPlace == null) {
        errors.push(this.translate.instant('calibrateEquipmentEdit.calibrationData.place.error') as string);
      }

      if (this.calibration.id != null) {
        if (ArrayUtils.isEmpty(this.calibration.tests)) {
          errors.push(this.translate.instant('calibrateEquipmentEdit.form.variables.essays') as string);
        } else {
          this.calibration.tests.forEach(v => {
            const essayName = this.getTestName(v.idTestType);

            if (v.idTestType === ParticleTestEnum.FLOW_RATE_AF) {
              if (!v.results) {
                errors.push(this.translate.instant('particlesTest.test.results.error', { essayName: essayName }))
              } else {
                v.results.forEach(vr => {
                  if (!vr.nominal) {
                    errors.push(this.translate.instant('particlesTest.test.nominal.error', { essayName: essayName }))
                  }

                  if (!vr.measured) {
                    errors.push(this.translate.instant('particlesTest.test.measured.error', { essayName: essayName }))
                  }

                  if (!vr.limit) {
                    errors.push(this.translate.instant('particlesTest.test.limit.error', { essayName: essayName }))
                  }

                  if (!vr.result) {
                    errors.push(this.translate.instant('particlesTest.test.result.error', { essayName: essayName }))
                  }

                  if (!vr.pass && !vr.fail) {
                    errors.push(this.translate.instant('particlesTest.dialog.test.passfail.error', { essayName: essayName }))
                  }
                });
              }
            }

            if (v.idTestType === ParticleTestEnum.FLOW_RATE_AL) {
              if (!v.results) {
                errors.push(this.translate.instant('particlesTest.test.results.error', { essayName: essayName }))
              } else {
                v.results.forEach(vr => {
                  if (!vr.nominal) {
                    errors.push(this.translate.instant('particlesTest.test.nominal.error', { essayName: essayName }))
                  }

                  if (!vr.measured) {
                    errors.push(this.translate.instant('particlesTest.test.measured.error', { essayName: essayName }))
                  }

                  if (!vr.limit) {
                    errors.push(this.translate.instant('particlesTest.test.limit.error', { essayName: essayName }))
                  }

                  if (!vr.result) {
                    errors.push(this.translate.instant('particlesTest.test.result.error', { essayName: essayName }))
                  }

                  if (!vr.pass && !vr.fail) {
                    errors.push(this.translate.instant('particlesTest.dialog.test.passfail.error', { essayName: essayName }))
                  }
                });
              }
            }

            if (v.idTestType === ParticleTestEnum.SIZE_SETTING_AF) {
              if (!v.results) {
                errors.push(this.translate.instant('particlesTest.test.results.error', { essayName: essayName }))
              } else {
                v.results.forEach(vr => {
                  if (!vr.channelPha) {
                    errors.push(this.translate.instant('particlesTest.test.channel.error', { essayName: essayName }))
                  }

                  if (!vr.previousValue) {
                    errors.push(this.translate.instant('particlesTest.test.previousValue.error', { essayName: essayName }))
                  }

                  if (!vr.median) {
                    errors.push(this.translate.instant('particlesTest.test.median.error', { essayName: essayName }))
                  }

                  if (!vr.ajustedValue) {
                    errors.push(this.translate.instant('particlesTest.test.ajustedValue.error', { essayName: essayName }))
                  }

                  if (!vr.limit) {
                    errors.push(this.translate.instant('particlesTest.test.limit.error', { essayName: essayName }))
                  }

                  if (!vr.result) {
                    errors.push(this.translate.instant('particlesTest.test.result.error', { essayName: essayName }))
                  }

                  if (!vr.pass && !vr.fail) {
                    errors.push(this.translate.instant('particlesTest.dialog.test.passfail.error', { essayName: essayName }))
                  }
                });
              }
            }

            if (v.idTestType === ParticleTestEnum.SIZE_SETTING_AL) {
              if (!v.results) {
                errors.push(this.translate.instant('particlesTest.test.results.error', { essayName: essayName }))
              } else {
                v.results.forEach(vr => {
                  if (!vr.channelPha) {
                    errors.push(this.translate.instant('particlesTest.test.channel.error', { essayName: essayName }))
                  }

                  if (!vr.previousValue) {
                    errors.push(this.translate.instant('particlesTest.test.previousValue.error', { essayName: essayName }))
                  }

                  if (!vr.median) {
                    errors.push(this.translate.instant('particlesTest.test.median.error', { essayName: essayName }))
                  }

                  if (!vr.ajustedValue) {
                    errors.push(this.translate.instant('particlesTest.test.ajustedValue.error', { essayName: essayName }))
                  }

                  if (!vr.limit) {
                    errors.push(this.translate.instant('particlesTest.test.limit.error', { essayName: essayName }))
                  }

                  if (!vr.result) {
                    errors.push(this.translate.instant('particlesTest.test.result.error', { essayName: essayName }))
                  }

                  if (!vr.pass && !vr.fail) {
                    errors.push(this.translate.instant('particlesTest.dialog.test.passfail.error', { essayName: essayName }))
                  }
                })
              }
            }

            if (v.idTestType === ParticleTestEnum.COUNTING_EFFICIENCY_AF) {
              if (!v.results) {
                errors.push(this.translate.instant('particlesTest.test.results.error', { essayName: essayName }))
              } else {
                v.results.forEach(vr => {
                  if (!vr.efficiencyTest) {
                    errors.push(this.translate.instant('particlesTest.test.efficiencyTest.error', { essayName: essayName }))
                  }

                  if (!vr.obtainedEfficiency) {
                    errors.push(this.translate.instant('particlesTest.test.obtainedEfficiency.error', { essayName: essayName }))
                  }

                  if (!vr.size) {
                    errors.push(this.translate.instant('particlesTest.test.size.error', { essayName: essayName }))
                  }

                  if (!vr.limit) {
                    errors.push(this.translate.instant('particlesTest.test.limit.error', { essayName: essayName }))
                  }

                  if (!vr.pass && !vr.fail) {
                    errors.push(this.translate.instant('particlesTest.dialog.test.passfail.error', { essayName: essayName }))
                  }
                });
              }
            }

            if (v.idTestType === ParticleTestEnum.COUNTING_EFFICIENCY_AL) {
              if (!v.results) {
                errors.push(this.translate.instant('particlesTest.test.results.error', { essayName: essayName }))
              } else {
                v.results.forEach(vr => {
                  if (!vr.efficiencyTest) {
                    errors.push(this.translate.instant('particlesTest.test.efficiencyTest.error', { essayName: essayName }))
                  }

                  if (!vr.obtainedEfficiency) {
                    errors.push(this.translate.instant('particlesTest.test.obtainedEfficiency.error', { essayName: essayName }))
                  }

                  if (!vr.size) {
                    errors.push(this.translate.instant('particlesTest.test.size.error', { essayName: essayName }))
                  }

                  if (!vr.limit) {
                    errors.push(this.translate.instant('particlesTest.test.limit.error', { essayName: essayName }))
                  }

                  if (!vr.pass && !vr.fail) {
                    errors.push(this.translate.instant('particlesTest.dialog.test.passfail.error', { essayName: essayName }))
                  }
                })
              }
            }

            if (v.idTestType === ParticleTestEnum.PEAK_NOISE_AF) {
              if (!v.results) {
                errors.push(this.translate.instant('particlesTest.test.results.error', { essayName: essayName }))
              } else {
                v.results.forEach(vr => {
                  if (!vr.noise) {
                    errors.push(this.translate.instant('particlesTest.test.measuredNoise.error', { essayName: essayName }))
                  }

                  if (!vr.signal) {
                    errors.push(this.translate.instant('particlesTest.test.measuredSignal.error', { essayName: essayName }))
                  }

                  if (!vr.limit) {
                    errors.push(this.translate.instant('particlesTest.test.limit.error', { essayName: essayName }))
                  }

                  if (!vr.result) {
                    errors.push(this.translate.instant('particlesTest.test.result.error', { essayName: essayName }))
                  }

                  if (!vr.pass && !vr.fail) {
                    errors.push(this.translate.instant('particlesTest.dialog.test.passfail.error', { essayName: essayName }))
                  }
                });
              }
            }

            if (v.idTestType === ParticleTestEnum.PEAK_NOISE_AL) {
              if (!v.results) {
                errors.push(this.translate.instant('particlesTest.test.results.error', { essayName: essayName }))
              } else {
                v.results.forEach(vr => {
                  if (!vr.noise) {
                    errors.push(this.translate.instant('particlesTest.test.measuredNoise.error', { essayName: essayName }))
                  }

                  if (!vr.signal) {
                    errors.push(this.translate.instant('particlesTest.test.measuredSignal.error', { essayName: essayName }))
                  }

                  if (!vr.limit) {
                    errors.push(this.translate.instant('particlesTest.test.limit.error', { essayName: essayName }))
                  }

                  if (!vr.result) {
                    errors.push(this.translate.instant('particlesTest.test.result.error', { essayName: essayName }))
                  }

                  if (!vr.pass && !vr.fail) {
                    errors.push(this.translate.instant('particlesTest.dialog.test.passfail.error', { essayName: essayName }))
                  }
                });
              }
            }

            if (v.idTestType === ParticleTestEnum.SLAMPING_TIME_AF) {
              if (!v.results) {
                errors.push(this.translate.instant('particlesTest.test.results.error', { essayName: essayName }))
              } else {
                v.results.forEach(vr => {
                  if (!vr.countTime) {
                    errors.push(this.translate.instant('particlesTest.test.count_time.error', { essayName: essayName }))
                  }

                  if (!vr.standarTime) {
                    errors.push(this.translate.instant('particlesTest.test.standar_time.error', { essayName: essayName }))
                  }

                  if (!vr.limit) {
                    errors.push(this.translate.instant('particlesTest.test.limit.error', { essayName: essayName }))
                  }

                  if (!vr.result) {
                    errors.push(this.translate.instant('particlesTest.test.result.error', { essayName: essayName }))
                  }

                  if (!vr.pass && !vr.fail) {
                    errors.push(this.translate.instant('particlesTest.dialog.test.passfail.error', { essayName: essayName }))
                  }
                });
              }
            }

            if (v.idTestType === ParticleTestEnum.SLAMPING_TIME_AL) {
              if (!v.results) {
                errors.push(this.translate.instant('particlesTest.test.results.error', { essayName: essayName }))
              } else {
                v.results.forEach(vr => {
                  if (!vr.countTime) {
                    errors.push(this.translate.instant('particlesTest.test.count_time.error', { essayName: essayName }))
                  }

                  if (!vr.standarTime) {
                    errors.push(this.translate.instant('particlesTest.test.standar_time.error', { essayName: essayName }))
                  }

                  if (!vr.limit) {
                    errors.push(this.translate.instant('particlesTest.test.limit.error', { essayName: essayName }))
                  }

                  if (!vr.result) {
                    errors.push(this.translate.instant('particlesTest.test.result.error', { essayName: essayName }))
                  }

                  if (!vr.pass && !vr.fail) {
                    errors.push(this.translate.instant('particlesTest.dialog.test.passfail.error', { essayName: essayName }))
                  }
                })
              }
            }

            if (v.idTestType === ParticleTestEnum.FALSE_COUNT_AF) {
              if (!v.results) {
                errors.push(this.translate.instant('particlesTest.test.results.error', { essayName: essayName }))
              } else {
                v.results.forEach(vr => {
                  if (!vr.obsAccount) {
                    errors.push(this.translate.instant('particlesTest.test.channel.error', { essayName: essayName }))
                  }

                  if (!vr.limit) {
                    errors.push(this.translate.instant('particlesTest.test.limit.error', { essayName: essayName }))
                  }

                  if (!vr.pass && !vr.fail) {
                    errors.push(this.translate.instant('particlesTest.dialog.test.passfail.error', { essayName: essayName }))
                  }
                });
              }
            }

            if (v.idTestType === ParticleTestEnum.FALSE_COUNT_AL) {
              if (!v.results) {
                errors.push(this.translate.instant('particlesTest.test.results.error', { essayName: essayName }))
              } else {
                v.results.forEach(vr => {
                  if (!vr.obsAccount) {
                    errors.push(this.translate.instant('particlesTest.test.channel.error', { essayName: essayName }))
                  }

                  if (!vr.limit) {
                    errors.push(this.translate.instant('particlesTest.test.limit.error', { essayName: essayName }))
                  }

                  if (!vr.pass && !vr.fail) {
                    errors.push(this.translate.instant('particlesTest.dialog.test.passfail.error', { essayName: essayName }))
                  }
                })
              }
            }

            if (v.idTestType === ParticleTestEnum.SIZE_RESOLUTION_AF) {
              if (!v.results) {
                errors.push(this.translate.instant('particlesTest.test.results.error', { essayName: essayName }))
              } else {
                v.results.forEach(vr => {
                  if (!vr.certSize) {
                    errors.push(this.translate.instant('particlesTest.test.cert_size.error', { essayName: essayName }))
                  }

                  if (!vr.obtResolution) {
                    errors.push(this.translate.instant('particlesTest.test.obt_resolution.error', { essayName: essayName }))
                  }

                  if (!vr.limit) {
                    errors.push(this.translate.instant('particlesTest.test.limit.error', { essayName: essayName }))
                  }

                  if (!vr.pass && !vr.fail) {
                    errors.push(this.translate.instant('particlesTest.dialog.test.passfail.error', { essayName: essayName }))
                  }
                });
              }
            }

            if (v.idTestType === ParticleTestEnum.SIZE_RESOLUTION_AL) {
              if (!v.results) {
                errors.push(this.translate.instant('particlesTest.test.results.error', { essayName: essayName }))
              } else {
                v.results.forEach(vr => {
                  if (!vr.certSize) {
                    errors.push(this.translate.instant('particlesTest.test.cert_size.error', { essayName: essayName }))
                  }

                  if (!vr.obtResolution) {
                    errors.push(this.translate.instant('particlesTest.test.obt_resolution.error', { essayName: essayName }))
                  }

                  if (!vr.limit) {
                    errors.push(this.translate.instant('particlesTest.test.limit.error', { essayName: essayName }))
                  }

                  if (!vr.pass && !vr.fail) {
                    errors.push(this.translate.instant('particlesTest.dialog.test.passfail.error', { essayName: essayName }))
                  }
                })
              }
            }
          });
        }
      }
    }

    return errors;
  }

  revertSign(): void {
    const errors = this.checkCalibration(false, false);

    if (errors.length !== 0) {
      this.snackBarService.sendError(errors.join('\n'));

      return;
    }

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: this.translate.instant('calibrateEquipmentEdit.form.revertSign.confirm') as string
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe(result => {
      if (result === true) {
        this.requestReason((reason) => {
          if (reason) {
            const dialogRefConfirmation = this.dialog.open(ActionConfirmPasswordComponent, {
              minWidth: '20%',
              maxHeight: '95vh',
              data: {}
            });

            dialogRefConfirmation.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((token: string) => {
              this.spinnerService.show();
              this.particleService.revertSign(this.calibration, reason, token).pipe(takeUntil(this.destroy$)).subscribe(() => {
                this.spinnerService.hide();
                this.reloadPage(this.calibration.id);
              }, error => {
                this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.form.status.back.error.generic') as string);
                this.spinnerService.hide();
              });

            }, error => {
              this.spinnerService.hide();
              if (error != null && error.error != null && typeof error.error === 'string') {
                this.snackBarService.sendError(error.error as string);
              } else {
                this.snackBarService.sendError(this.translate.instant('calibrateEquipmentEdit.form.status.back.error.generic') as string);
              }
            });

          }
        });
      }
    });
  }

  checkAccording(test: ParticleTest): string {

    if (!test.id || ArrayUtils.isEmpty(test.results)) {
      return 'essayPendingEvaluation'
    }

    if (test.results.some(s => s.pass === null && s.fail === null || (s.pass === undefined && s.fail === undefined))) {
      return 'essayPendingEvaluation'
    }

    if (test.results.some(s => !s.pass && !s.fail)) {
      return 'essayPendingEvaluation'
    }

    if (test.results.some(s => s.fail)) {
      return 'essayNotAccording'
    }

    return 'essayAccording';
  }

  private downloadFile(calibration: ParticleCalibration, file: File) {
    this.internalEquipmentService.findOne(calibration.idEquipment).pipe(takeUntil(this.destroy$))
      .subscribe((equipment: InternalEquipment) => {
        const name = CalibrationParticlesUtils.getNameForCalibration(this.calibration, equipment, this.translate);
        saveAs(file, name);
        this.spinnerService.hide();
      });
  }

  private showSign() {
    return this.calibration.idStatus === CalibrationStatus.PENDIENTE_FIRMA;
  }

  private prepareToSave() {
    this.calibration.expirationDate = DateUtils.anyToDate(this.calibration.expirationDate);
    this.calibration.calibrationDate = DateUtils.anyToDate(this.calibration.calibrationDate);
  }

  private findClient(): void {
    if (this.equipment.internal) {
      this.reloadPage(this.calibration.id);
    } else {
      this.clientService.findOne(this.equipment.client.id).subscribe((client: Client) => {

        if (client.idGroup != null) {
          //void this.cloneRow(this.calibration.id, client.idGroup).then(() => this.reloadPage(this.calibration.id));
        } else {
          this.reloadPage(this.calibration.id);
        }

      });
    }
  }


  private requestReason(callback: (reason: string) => void) {
    const dialogRef = this.dialog.open(ReasonDialogComponent, {
      minWidth: '40%',
      maxHeight: '95vh',
      data: {}
    });

    dialogRef.afterClosed().pipe(takeUntil(this.destroy$)).subscribe((result: string) => {
      if (result != null) {
        callback(result);
      }
    });
  }
}
